// @ts-check

import { toKebabCase } from "../../shared/utils/string";
import { extractComponentName } from "./utils";

/**
 * Registers a custom element.
 *
 * The name of the custom element will be derived from the custom element file name.
 * The custom element will be registered under the "sp-" prefix.
 * For example, the custom element file name "MyComponent.ce.vue" will be registered as "sp-my-component".
 *
 * @param {string} fileName
 * @param {import("vue").VueElementConstructor<{}>} elementConstructor
 */
export function registerCustomElement(fileName, elementConstructor) {
  const elementName = toKebabCase(extractComponentName(fileName));
  const isAlreadyRegistered = customElements.get(elementName);

  if (isAlreadyRegistered) {
    return;
  }

  /**
   * A custom element that is aware of the form association.
   * This is required to use the custom element in a form.
   *
   * TODO: @sleistner - conditionally set formAssociated based on the component settings.
   *
   * @see https://html.spec.whatwg.org/multipage/custom-elements.html#concept-element-form-associated
   */
  const FormAwareComponentClass = class extends elementConstructor {
    static formAssociated = true;
  };

  customElements.define(elementName, FormAwareComponentClass);
}
